import { createFileRoute } from '@tanstack/react-router';
import { TopLevelPage } from '@/components/top-level-page';
import { PaymentsSettingsPage } from '@/features/checkout/pages/payments-settings-page';

export const Route = createFileRoute('/_app/receiving-accounts')({
  component: () => (
    <TopLevelPage path="/receiving-accounts">
      <PaymentsSettingsPage />
    </TopLevelPage>
  ),
});
